// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty_txt {
  text-align: center;
  margin-top: 140px;
  color: #dabfa1;
}

.receipts .receipt {
  margin: auto;
  background: #fff;
  width: 22rem;
  padding: 1rem 1rem 2rem;
  margin-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  --mask: conic-gradient(from -45deg at bottom, #0000, #000 1deg 89deg, #0000 89deg) 10%/20px 100%;
  -webkit-mask: var(--mask);
  mask: var(--mask);
}
.receipts .receipt h1 {
  color: #e7ccb7;
}
.receipts .receipt .pay_type {
  margin-top: 50px;
  margin-bottom: 10px;
  font-size: 18px;
  color: #d9d9d9;
  text-transform: uppercase;
}
.receipts .receipt .lighter {
  font-style: italic;
  font-size: 12px;
  color: #6f6f6f;
}
.receipts .receipt hr {
  background: #ffefe4;
  height: 2px;
  border-radius: 16px;
}
.receipts .receipt table {
  border-collapse: collapse;
  width: 100%;
}
.receipts .receipt table td,
.receipts .receipt table th {
  text-align: left;
  padding: 8px;
}
.receipts .receipt table th {
  font-weight: bold;
}
.receipts .receipt table .rt {
  text-align: right;
}
.receipts .receipt h4 {
  text-align: left;
}
.receipts .receipt .history {
  text-align: left;
  font-size: 12px;
  color: #8e8e8e;
}`, "",{"version":3,"sources":["webpack://./src/app/receipts/receipts.page.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,iBAAA;EACA,cAAA;AACJ;;AAGI;EACI,YAAA;EACA,gBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EAEA,gGAAA;EACA,yBAAA;EACA,iBAAA;AADR;AAGQ;EACI,cAAA;AADZ;AAIQ;EACI,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,yBAAA;AAFZ;AAKQ;EACI,kBAAA;EACA,eAAA;EACA,cAAA;AAHZ;AAMQ;EACI,mBAAA;EACA,WAAA;EACA,mBAAA;AAJZ;AAOQ;EACI,yBAAA;EACA,WAAA;AALZ;AAOY;;EAEI,gBAAA;EACA,YAAA;AALhB;AAQY;EACI,iBAAA;AANhB;AASY;EACI,iBAAA;AAPhB;AAWQ;EACI,gBAAA;AATZ;AAYQ;EACI,gBAAA;EACA,eAAA;EACA,cAAA;AAVZ","sourcesContent":[".empty_txt {\n    text-align: center;\n    margin-top: 140px;\n    color: #dabfa1;\n}\n\n.receipts {\n    .receipt {\n        margin: auto;\n        background: #fff;\n        width: 22rem;\n        padding: 1rem 1rem 2rem;\n        margin-top: 20px;\n        margin-bottom: 20px;\n        text-align: center;\n\n        --mask: conic-gradient(from -45deg at bottom, #0000, #000 1deg 89deg, #0000 89deg) 10%/20px 100%;\n        -webkit-mask: var(--mask);\n        mask: var(--mask);\n\n        h1 {\n            color: #e7ccb7;\n        }\n\n        .pay_type {\n            margin-top: 50px;\n            margin-bottom: 10px;\n            font-size: 18px;\n            color: #d9d9d9;\n            text-transform: uppercase;\n        }\n\n        .lighter {\n            font-style: italic;\n            font-size: 12px;\n            color: #6f6f6f;\n        }\n\n        hr {\n            background: #ffefe4;\n            height: 2px;\n            border-radius: 16px;\n        }\n\n        table {\n            border-collapse: collapse;\n            width: 100%;\n\n            td,\n            th {\n                text-align: left;\n                padding: 8px;\n            }\n\n            th {\n                font-weight: bold;\n            }\n\n            .rt {\n                text-align: right;\n            }\n        }\n\n        h4 {\n            text-align: left;\n        }\n\n        .history {\n            text-align: left;\n            font-size: 12px;\n            color: #8e8e8e;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
